<template>
  <select v-if="!loading" name="lang" id="lang" class="lang" @change="changeLang" v-model="value">
    <option v-for="lang in languages" :value="lang" :key="lang">
      {{ lang }}
    </option>
  </select>
</template>

<script>

import { switchLanguage } from '@/calls/switchLanguage';

export default {
  beforeMount() {
    const { locale } = this.$route.params;
    const currentLang = localStorage.getItem('lang');
    if (currentLang) {
      this.value = currentLang;
      document.documentElement.setAttribute('lang', currentLang);
      if (this.$i18n.locale !== this.value) {
        this.$i18n.locale = this.value;
      }
      if(currentLang, locale)
      if (currentLang !== locale) {
        const to = this.$router.resolve({ params: { locale: this.value } });
        this.$router.push(to.location);
      }
    }
  },
  data() {
    return {
      value: 'ko'
    };
  },
  computed: {
    exhibition() {
      return this.$store.state.exhibitions.item;
    },
    languages() {
      return this.exhibition ? this.exhibition.languages : process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
    },
    loading() {
      return this.$store.state.exhibitions.requests !== 0;
    }
  },
  methods: {
    async changeLang(e) {
      const { currentTarget } = e;
      const { value } = currentTarget;
      document.documentElement.setAttribute('lang', value);

      const data = new FormData();
      data.append('from_lang', this.$route.params.locale);
      data.append('to_lang', value);
      data.append('exhibition_id', this.$route.params.id);
      data.append('chapter_id', this.$route.params.chapterId);
      data.append('story_id', this.$route.params.storyId);

      const translatedSlugs = await switchLanguage(data);

      localStorage.setItem('lang', value);
      this.$store.commit('user/setLang', value)

      console.log(this.$route.params.id)
      this.$store.dispatch('stories/get', { id: this.$route.params.id, loc: value });
      this.$store.dispatch('chapters/get', { id: this.$route.params.id, loc: value });


      // const response = await this.$store.dispatch('exhibitions/getCurrent', { loc: value });
      // console.log(response)
      // this.$store.dispatch('stories/getDetail', { id: storyId, loc: value });
      // this.$store.dispatch('stories/get', { id: this.exhibition.id, loc: value });
      // this.$store.dispatch('chapters/get', { id: this.exhibition.id, loc: value });
      // this.$store.dispatch('exhibitions/getDetail', { id: this.exhibition.id, loc: value });
      // this.$store.dispatch('terms/get', value);

       if (this.$i18n !== value) {
        this.$i18n.locale = value;

        const params = { locale: value, id: this.$route.params.id };

        // Replace by translatedSlugs slugs
        if (this.$route.params.chapterId) {
          params.chapterId = translatedSlugs.to.chapter_id;
        }
        if (this.$route.params.storyId) {
          params.storyId = translatedSlugs.to.story_id;
        }
        if (this.$route.params.id) {
          params.id = translatedSlugs.to.exhibition_id;
        }

        const to = this.$router.resolve({ params });

        this.$router.push(to.location);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
    .lang {
        display: block;
        padding: 0;
        margin: 0;
        height: 34px;
        width: 28px;
        box-sizing: border-box;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        color: $grey-light;
        font-size: rem(11px);
        text-transform: uppercase;
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' id='Calque_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 7.7 4.5' style='enable-background:new 0 0 7.7 4.5;fill:%23ffffff;' xml:space='preserve'%3E%3Cg transform='translate(478.396 -491.639) rotate(90)'%3E%3Cpolygon class='st0' points='496.1,474.5 492.4,478.4 491.6,477.7 494.7,474.5 491.6,471.4 492.4,470.6 '/%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0 top 51%, 0 0;
        background-size: 7px;
    }
</style>
